import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["cta", "typeformUrl", "trackEvent", "trackingOnSubmit", "onSubmit"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { targetPropType } from "../../constants/target";
import { onTrackItemClickEvent, trackingPropType } from "../../util/tracking";
import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import Typeform from "../common/typeform";

// This regex matches the one in Contentful:
// https://app.contentful.com/spaces/co0pvta7hzrh/content_types/mlp-typeform-embed-module/fields
import { jsx as _jsx } from "react/jsx-runtime";
var urlRegex = /https?.*:\/\/.*\.typeform\.com\/([a-z]+)\/([a-zA-Z0-9]*)/;
var TypeformEmbedModule = function TypeformEmbedModule(props) {
  var cta = props.cta,
    typeformUrl = props.typeformUrl,
    trackEvent = props.trackEvent,
    trackingOnSubmit = props.trackingOnSubmit,
    onSubmit = props.onSubmit,
    rest = _objectWithoutProperties(props, _excluded);
  var onClick = useCallback(function () {
    onTrackItemClickEvent(cta, trackEvent);
  }, [cta, trackEvent]);
  var handleSubmit = useCallback(function (event) {
    if (trackingOnSubmit && trackEvent) {
      onTrackItemClickEvent({
        tracking: trackingOnSubmit
      }, trackEvent);
    }
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(event);
  }, [trackingOnSubmit, trackEvent, onSubmit]);
  if (!typeformUrl) return null;
  var result = urlRegex.exec(typeformUrl);
  if (!result || result.length <= 2) return null;
  var _result = _slicedToArray(result, 3),
    formType = _result[1],
    formId = _result[2];
  var isChat = formType === 'c';
  var text = get(cta, 'text');
  var url = get(cta, 'url');
  return /*#__PURE__*/_jsx(Typeform, _objectSpread({
    formId: formId,
    isChat: isChat,
    onClick: onClick,
    onSubmit: handleSubmit,
    text: text,
    url: url
  }, rest));
};
TypeformEmbedModule.displayName = 'TypeformEmbedModule';
TypeformEmbedModule.propTypes = {
  cta: PropTypes.shape({
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    target: targetPropType,
    tracking: trackingPropType
  }),
  noContainer: PropTypes.bool,
  typeformUrl: PropTypes.string.isRequired,
  trackEvent: PropTypes.func,
  onReady: PropTypes.func,
  onSubmit: PropTypes.func,
  onQuestionChanged: PropTypes.func,
  inlineOnMobile: PropTypes.bool,
  trackingOnSubmit: PropTypes.shape({
    item: PropTypes.string,
    item_name: PropTypes.string,
    location: PropTypes.string,
    typeform_property: PropTypes.string
  }),
  standAlone: PropTypes.bool
};
TypeformEmbedModule.defaultProps = {
  cta: null,
  noContainer: false,
  trackEvent: function trackEvent() {},
  onReady: undefined,
  onSubmit: undefined,
  onQuestionChanged: undefined,
  inlineOnMobile: false,
  trackingOnSubmit: undefined,
  standAlone: false
};
export default /*#__PURE__*/memo(TypeformEmbedModule);